import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  width: 100%;
`;

export const SeeMoreAnswersButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  padding-top: 12px;
`;

export const SeeMoreAnswersWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  width: 100%;
  height: 100%;
`;

export const ThreadWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 32px;
  flex-shrink: 0;
  padding-bottom: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 2px;
    height: 50%;
    background-color: ${({ theme }) => theme.colors.black3};
  }
`;

export const AvatarThreadWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 0 0 10px;
  height: 22px;
  width: 17px;
  border-left: 2px solid ${({ theme }) => theme.colors.black3};
  border-bottom: 2px solid ${({ theme }) => theme.colors.black3};
`;
